export const FETCH_COIN_SUPPORT = 'fetchCoinSupport';
export const FETCH_COIN_SUPPORT_IF_EMPTY = 'fetchCoinSupportIfEmpty';

export const FETCH_SUBSCRIPTIONS = 'fetchSubscription';

export const SET_SELECTED_SUBSCRIPTION = 'setSelectedSubscription';

export const SET_WINDOW_LOCATION = 'setWindowLocation';
export const SET_VENDOR_INFO = 'setVendorInfo';
export const FETCH_VENDOR_INFO = 'fetchVendorInfo';
